<div class="df-modal-header">
  <h4 class="df-modal-title">
    @switch (usecase) {
      @case (deleteAssetgroup) {
        <ng-container i18n="@@assetgroup.delete_confirmation_title">Delete Credential Set</ng-container>
      }
      @case (deleteAsset) {
        <ng-container i18n="@@asset.delete_confirmation_title">Delete Airline Credential</ng-container>
      }
      @case (unlinkAssetgroup) {
        <ng-container i18n="@@assetgroup.unlink_confirmation_title">Unlink Credential Set</ng-container>
      }
      @default {
        <ng-container i18n="@@delete_confirmation_title">Delete</ng-container>
      }
    }
  </h4>
  <button type="button" class="df-modal-close" aria-label="Close" (click)="activeModal.dismiss(false)">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
</div>
<div class="df-modal-body">
  <p class="df-modal-message">
    @switch (usecase) {
      @case (deleteAssetgroup) {
        <ng-container i18n="@@assetgroup.delete_confirmation_message">You are about to delete the Credential Set along with its Airline Credentials.<br/>Are you sure you want to delete the selected Credential Set?</ng-container>
      }
      @case (deleteAsset) {
        <ng-container i18n="@@asset.delete_confirmation_message">You are about to remove this Airline Credential from the Credential Set. <br/>Are you sure you want to remove the selected Airline Credential?</ng-container>
      }
      @case (unlinkAssetgroup) {
        <ng-container i18n="@@assetgroup.unlink_confirmation_message">You are about to unlink this Credential Set. <br/>Users will no longer have access to the credentials in this set. <br/> Are you sure you want to unlink selected items?</ng-container>
      }
      @default {
        <ng-container i18n="@@delete_confirmation_message">Confirm Deletion</ng-container>
      }
    }
  </p>
</div>
<div class="df-modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)" i18n="@@action.no">Cancel</button>
  <button type="button" class="btn btn-danger" (click)="activeModal.close(true)" i18n="@@action.yes">Delete</button>
</div>
